import { queryOptions, useQuery } from '@tanstack/react-query';

import { systemApi } from '../api/system-api';

import { systemKeys } from './system-keys';

export const API_STATUS_REFRESH_MS = 30_000;

/** Never throws: an unreachable API is a state of the dots, not an error of the screen. */
export function apiStatusQueryOptions() {
  return queryOptions({
    queryKey: systemKeys.status(),
    queryFn: systemApi.status,
    staleTime: API_STATUS_REFRESH_MS / 2,
    refetchInterval: API_STATUS_REFRESH_MS,
    retry: false,
    meta: { silentError: true },
  });
}

export function useApiStatus() {
  return useQuery(apiStatusQueryOptions());
}
